import {Grid, Typography, Link} from "@mui/material";

const Tarjeta_Proyecto = ({imagen, tipo, titulo, descripcion, link}) => {

    return (

        <Link href={link} underline={'none'} sx={{ width: '100%'}}>
            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                //  size={{xs: 12, sm: 12, md: 12}}
                sx={{
                    background: '#FAFCFE',
                    border: '1px solid #E8EAEE',
                    width: '100%',
                    p: 3,
                   // minHeight: '160px',
                    transition: 'border 0.3s', // suaviza la animación
                    '&:hover': {
                        border: '1px solid #66B3FF', // borde azul al hacer hover
                    },
                }}
            >

                <Grid container
                      justifyContent={'center'}
                      alignItems={'center'}
                      size={{xs: 12, sm: 12, md: 3}}
                      sx={{
                          // background: '#EBF5FF',
                          width: '70px',
                          height: '70px',
                          //border: '1px solid #9ECCF7',
                          // borderRadius: 4
                      }}>
                    <img src={imagen} alt={tipo} width='60px' height=''/>
                </Grid>
                {/*<Grid container size={{xs: 12, sm: 12, md: 12}} sx={{pt: 1}}>*/}
                {/*    <Typography variant={'small'} sx={{color: '#303741'}}>*/}
                {/*        {tipo}*/}
                {/*    </Typography>*/}
                {/*</Grid>*/}

                <Grid container size={{xs: 12, sm: 12, md: 9}}>
                    <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{pt: 1}}>
                        <Typography variant={'h5'} component={'h2'}>
                            {titulo}
                        </Typography>
                    </Grid>

                    <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{pt: 1}}>
                        <Typography variant={'body1'} sx={{width: '100%'}}>
                            {descripcion}
                        </Typography>
                    </Grid>
                </Grid>


            </Grid>
        </Link>


    )

}
export default Tarjeta_Proyecto
//
//
// <Grid container size={{xs: 12, sm: 12, md: 12}}>
// <Link href={link} underline={'none'}>
//     <Grid
// container
// justifyContent={'flex-start'}
// alignItems={'flex-start'}
// size={{xs: 12, sm: 12, md: 12}}
// sx={{
//     background: '#FAFCFE',
//         border: '1px solid #E8EAEE',
//
//         p: 3,
//         minHeight: '220px',
//         transition: 'border 0.3s', // suaviza la animación
//         '&:hover': {
//         border: '1px solid #66B3FF', // borde azul al hacer hover
//     },
// }}
// >
//
// <Grid container
// justifyContent={'center'}
// alignItems={'center'}
// sx={{
//     // background: '#EBF5FF',
//     width: '70px',
//         height: '70px',
//     //border: '1px solid #9ECCF7',
//     // borderRadius: 4
// }}>
// <img src={imagen} alt={tipo} width='' height='60px'/>
//     </Grid>
// {/*<Grid container size={{xs: 12, sm: 12, md: 12}} sx={{pt: 1}}>*/}
// {/*    <Typography variant={'small'} sx={{color: '#303741'}}>*/}
// {/*        {tipo}*/}
// {/*    </Typography>*/}
// {/*</Grid>*/}
//
// <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{pt: 1}}>
//     <Typography variant={'h5'} component={'h2'}>
//         {titulo}
//     </Typography>
// </Grid>
//
// <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{pt: 1}}>
//     <Typography variant={'body1'}>
//         {descripcion}
//     </Typography>
// </Grid>
//
// </Grid>
// </Link>
// </Grid>